import { render, staticRenderFns } from "./CollapseTransition.vue?vue&type=template&id=3a2d10ed&"
import script from "./CollapseTransition.vue?vue&type=script&lang=js&"
export * from "./CollapseTransition.vue?vue&type=script&lang=js&"
import style0 from "./CollapseTransition.vue?vue&type=style&index=0&id=3a2d10ed&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports